import React from "react";
import { Button, Space } from "antd";
import { BorderOutlined, AppstoreOutlined } from "@ant-design/icons";

type ValueType = "SINGLE" | "MULTIPLE";

interface PhotoGridButtonsProps {
  value: "AUTO" | ValueType;
  onClick: (value: ValueType) => void;
}

const PhotoGridButtons = ({ value, onClick }: PhotoGridButtonsProps) => {
  return (
    <Space.Compact role="group" aria-label="Photo layout">
      <Button
        onClick={() => onClick("SINGLE")}
        aria-label="Single-column photo layout"
        aria-pressed={value === "SINGLE"}
        className="photo-layout-button"
        color="default"
        variant="filled"
        size="small"
        icon={<BorderOutlined />}
      />
      <Button
        onClick={() => onClick("MULTIPLE")}
        aria-label="Grid photo layout"
        aria-pressed={value === "MULTIPLE"}
        className="photo-layout-button"
        color="default"
        variant="filled"
        size="small"
        icon={<AppstoreOutlined />}
      />
    </Space.Compact>
  );
};

export default PhotoGridButtons;
